import { useQuery } from '@tanstack/react-query';
import { getVideo } from '../services/admin/admin-video.service';
import { AdminVideo } from '../common/model/dto/video/admin-video';
import { ADMIN_VIDEO_KEY } from '../common/utils/video-query-cache';
import { getHttpStatus } from '../common/utils/http-status';
import { isArchived } from '../common/utils/video-status-utils';

export function usePendingReplacement({
  replaces_video_id,
  status,
  archived_at,
}: AdminVideo) {
  const isPending = !!replaces_video_id && status !== 'ready' && !archived_at;

  const { data: replaced, error } = useQuery({
    queryKey: [ADMIN_VIDEO_KEY, replaces_video_id],
    queryFn: () => getVideo(replaces_video_id ?? ''),
    enabled: isPending,
  });

  const isReplacedGone =
    getHttpStatus(error) === 404 || (!!replaced && isArchived(replaced));

  return {
    isPending,
    replaced,
    takesOver: isPending && !isReplacedGone,
  };
}
